const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_P0.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p0_w.path.lingerie.linkName',
        title: 'p0_w.path.lingerie.title',
        info: 'p0_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_Lenceria.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.lingerie.description.title',
          content: 'p0_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p0_w.path.payAndGo.linkName',
        title: 'p0_w.path.payAndGo.title',
        info: 'p0_w.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_Pay&Go_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_Pay&Go.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.payAndGo.description.title',
          content: 'p0_w.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p0_w.path.pickup.linkName',
        title: 'p0_w.path.pickup.title',
        info: 'p0_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_ReciclajeRopa_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_ReciclajeRopa.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.pickup.description.title',
          content: 'p0_w.path.pickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P0_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_P1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_P1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p1_w.path.beauty.linkName',
        title: 'p1_w.path.beauty.title',
        info: 'p1_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.beauty.description.title',
          content: 'p1_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_w.path.shoes.linkName',
        title: 'p1_w.path.shoes.title',
        info: 'p1_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Calzado.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.shoes.description.title',
          content: 'p1_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_w.path.pickUpSize.linkName',
        title: 'p1_w.path.pickUpSize.title',
        info: 'p1_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_P1_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickUpSize.description.title',
          content: 'p1_w.path.pickUpSize.description.content',
        },
      },
    ],
  },
  s1_m: {
    sectionPath: '/floor_-1',
    locationKey: 's1_m',
    sectionKey: 'MAN',
    floorKey: '-1',
    section: 's1_m.section.name',
    floor: 's1_m.floor.name',
    title: 'Título del Sótano',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/3/p/2224/766/800/303/w/649/2224766800_15_1_1.jpg?ts=1642521515572',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_S1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/12477_S1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_-1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 's1_m.path.floorMap.linkName',
        title: 's1_m.path.floorMap.title',
        info: 's1_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_m.path.floorMap.description.title',
          content: 's1_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/athleticz',
        exact: true,
        location: 'athleticz',
        linkName: 's1_m.path.athleticz.linkName',
        title: 's1_m.path.athleticz.title',
        info: 's1_m.path.athleticz.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Athleticz_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Athleticz.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 's1_m.path.athleticz.description.title',
          content: 's1_m.path.athleticz.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 's1_m.path.shoes.linkName',
        title: 's1_m.path.shoes.title',
        info: 's1_m.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Calzado.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 's1_m.path.shoes.description.title',
          content: 's1_m.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 's1_m.path.selfCheckout.linkName',
        title: 's1_m.path.selfCheckout.title',
        info: 's1_m.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 's1_m.path.selfCheckout.description.title',
          content: 's1_m.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 's1_m.path.pickUpSize.linkName',
        title: 's1_m.path.pickUpSize.title',
        info: 's1_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/12477_S1_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_m.path.pickUpSize.description.title',
          content: 's1_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'es-ES',
    name: 'Español',
  },
  {
    language: 'gl-ES',
    name: 'Galego',
  },
  {
    language: 'eu-ES',
    name: 'Euskara',
  },
  {
    language: 'ca-ES',
    name: 'Català',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/12477_ZARA_JUAN_DE_AUSTRIA_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
